import { auditFieldNames } from "../model/metaData";

export interface StringIndexObject {
  [key: string]: number;
}

export const fiterAuditUserObjectFields = (obj: any): any => {
  const { createdByUser, lastUpdatedByUser, ...rest } = obj;
  return rest;
};

export const fiterAuditObjectFieldsForArray = (response: any[]): any[] => {
  return response.map((item) => fiterAuditUserObjectFields(item));
};

export const filterObjectFields = (obj: any, readOnlyFields: string[]): any => {
  const newObj = { ...obj };
  readOnlyFields.forEach((field) => {
    delete newObj[field];
  });
  return newObj;
};

export const filterAuditReadOnlyFields = (obj: any): any => {
  return filterObjectFields(obj, auditFieldNames);
};

export const filterObjectFieldsForArray = (response: any[], readOnlyFields: string[]): any[] => {
  return response.map((item) => filterObjectFields(item, readOnlyFields));
};
